export default __webpack_public_path__ + "static/media/sduzrdd.ae7c4392.png";